

import React, { useState, useEffect, useRef, useCallback } from 'react'

import Grid from '@material-ui/core/Grid';
import ImputComponent from "../../InputComponent"
import { LanguageFactory, LocalPersistence } from '../../../factories';
import { useLanguage } from '../../../store/languageContext'
import SearchDebounceBar from '../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../factories/propertySearchs';
import { Button, Card, Table, message } from 'antd';
import { getRefPoints } from '../../../services/referencepoint';
import Loading from '../../Loading';
// import AddReference from './Add';
import TabInfo from './TabInfo';
import PageContainer from '../../CSIComponents/PageContainer';
import { sortHelper } from '../../../helpers/misc/sortHelper'
import { paginationSize, getPaginationSession } from '@helpers/misc/setPaginationSize'


const TabpanelDetail = (props: any) => {
    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [addFlag, setAddFlag] = useState(false)
    const [detailFlag, setdetailFlag] = useState(false)
    const [rowData, setRowData] = useState([]);
    const [addLoading, setAddLoading] = useState(false)
    const [dataSource, setDataSource] = useState([]);
    const [total, setTotal] = useState(dataSource.length)
    const [searchs, setSearch] = useState<string[]>([])
    const [data, setData] = useState(dataSource);
    const [isdetail, setIsdetail] = useState(false)
    const [paginationData, setPaginationData] = useState<number>(10)

    const test = () => {
        setAddFlag(false)
    }
    const testDetailFlag = () => {
        setdetailFlag(false)
    }

    const columns = [
        {
            title: '',
            key: 'index',
            // @ts-expect-error
            render: (text: string, record: [], index: number) => Number(record?.key) ? Number(record?.key) + 1 : index += 1,
            width: '40px'
          },
        {
            title: lang.translate(language, 'Reference_name'),
            dataIndex: 'name',
            key: 'name',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'name'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'Reference_type'),
            dataIndex: 'type',
            key: 'type',
            sorter: (a: [], b: []) => sortHelper(a, b, 'type'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'Reference_code'),
            dataIndex: 'airportcode',
            key: 'airportcode',
            sorter: (a: [], b: []) => sortHelper(a, b, 'airportcode'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'Reference_category'),
            dataIndex: 'category',
            key: 'category',
            sorter: (a: [], b: []) => sortHelper(a, b, 'category'),
            showSorterTooltip: false
        },
        {
            title: lang.translate(language, 'Reference_direction'),
            dataIndex: 'directiondescription',
            key: 'directiondescription',
            ellipsis: {
                showTitle: false,
            },
            sorter: (a: [], b: []) => sortHelper(a, b, 'directiondescription'),
            showSorterTooltip: false
        }
    ]
    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }

    const getPaginationData = useCallback(async () => {
        return await getPaginationSession(
            setPaginationData,
            'reference_points'
        );
    }, [])

    const getData = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        setAddLoading(true)
        await getPaginationData()
        getRefPoints(session.supplier, session.propertyId).then(res => {
            setAddLoading(false)
            if (res.result.success) {
                const resData = res && res.property && res.property.referencepoint && res.property.referencepoint.length > 0 ? res.property.referencepoint : [];
                resData.forEach((item: any, index: number) => { item.key = '' + index; })
                setDataSource(resData);
                setData(resData)
            } else {
                message.error({
                    content: res?.error[0]?.message || 'operation failed'
                });
            }
        }, err => {
            message.error({
                content: err.message || err.error[0].message
            });
            setAddLoading(false)
        });
        // const res = await getRefPoints(session.supplier, session.propertyId);
        // setAddLoading(false)
        // const resData = res && res.property && res.property.referencepoint && res.property.referencepoint.length > 0 ? res.property.referencepoint : [];
        // resData.forEach((item: any, index: number) => { item.key = '' + index; })
        // setDataSource(resData);
        // setData(resData)
    }
    useEffect(() => {
        getData()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])
    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const itemData: any = {}
            columns.forEach((col: any) => {
                itemData[col['dataIndex']] = item[col.dataIndex]?.toLowerCase() || '';
            })
            return JSON.stringify(Object.values(item))
                .toLocaleLowerCase()
                .indexOf(query.toLocaleLowerCase()) > -1;
        })
        setDataSource(filterData);
    }
    useEffect(() => {
        setTotal(dataSource.length)
    }, [dataSource])
    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [searchTermDebounced])
    
    return (addLoading ? <Loading type="large" /> : <div>
        <PageContainer>
            {!addFlag && !detailFlag && <Card style={{ marginTop: -15 }}>
                <Grid container spacing={0} className="containerSpacing py-0">
                    <Grid item xs={12} className="p-0">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ fontWeight: 'bold' }}> Reference Points</div>
                            <div><Button className="db-add-btn" onClick={() => { props.isEditable(); setAddFlag(true) }}>Add</Button></div>
                        </div>
                    </Grid>
                    <Grid item xs={4} className="pb-0 px-0 my-0">
                        <ImputComponent
                            className='SearchBar'
                            //label={lang.translate(language, 'search')}
                            label={'Search'}
                            labelShrink={true}
                            value={searchTerm}
                            onChange={onChangeSearch}
                            placeholder={lang.translate(language, 'Reference_search')}
                            endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                        />
                        <div className="recentlySearchs">
                            <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} className="p-0">
                        <Table
                            columns={columns}
                            dataSource={
                                dataSource
                            }
                            pagination={{
                                size: "small",
                                total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                                defaultPageSize: paginationData,
                                defaultCurrent: 1,
                                onShowSizeChange: (current, size: number) => paginationSize('pagination', { 'reference_points': size })
                                }}
                            onRow={record => {
                                return {
                                    onClick: event => {
                                        setdetailFlag(true);
                                        setIsdetail(true);
                                        setRowData(record);
                                    },
                                };
                            }}
                        />
                    </Grid>
                </Grid>
            </Card>}

        </PageContainer>
        {addFlag && <TabInfo getData={getData} test={test} setAddFlag={setAddFlag} add="true" isEditable={props.isEditable} cancelEditable={props.cancelEditable} />}
        {detailFlag && <TabInfo getData={getData} testDetailFlag={testDetailFlag} setdetailFlag={setdetailFlag} isdetail={isdetail} rowData={rowData} isEditable={props.isEditable} cancelEditable={props.cancelEditable} />}
    </div>
    )
}

export default TabpanelDetail;

